import { render, staticRenderFns } from "./VerifiedIcon.vue?vue&type=template&id=ea75f81a&"
import script from "./VerifiedIcon.vue?vue&type=script&lang=js&"
export * from "./VerifiedIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports